const Search = () => {
  return (
    <div  className="search options">
      <div>
        <h2>Intelligent search</h2>
        <p>Our powerful search feature will help you find saved sites in no time at all. No need to trawl through all of your bookmarks.</p>
        <button>More Info</button>
      </div>
    </div>
  )
}

export default Search